<template>
  <div class="step-three">
    <h2 class="text-h6 mb-4">{{ $t('onboarding.step3.description') }}</h2>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <!-- Mandate HTML -->
    <div
      v-if="mandateHtml"
      class="mandate-box pa-4 mb-4"
      style="max-height: 400px; overflow-y: auto; border: 1px solid #ccc; border-radius: 4px; background: white;"
    >
      <div v-html="mandateHtml"></div>
    </div>

    <!-- Consent checkbox -->
    <v-checkbox
      v-model="accepted"
      :label="$t('onboarding.step3.accept-mandate')"
      :disabled="loading"
      dense
      hide-details
      class="mb-4"
    ></v-checkbox>

    <div class="d-flex justify-space-between mt-6">
      <v-btn
        text
        small
        :disabled="loading"
        @click="$emit('back')"
      >
        <v-icon left small>mdi-arrow-left</v-icon>
        {{ $t('back') }}
      </v-btn>
      <v-btn
        color="primary"
        small
        :loading="loading"
        :disabled="!accepted"
        @click="handleNext"
      >
        {{ $t('onboarding.step3.confirm') }}
        <v-icon right small>mdi-check</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepThree',

  props: {
    mandateHtml: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      accepted: false
    }
  },

  methods: {
    handleNext() {
      if (this.accepted) {
        this.$emit('next')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-three {
  .mandate-box {
    font-size: 14px;
  }
}
</style>
